/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import ErrorWrapper from '@/components/error-wrapper/ErrorWrapper.vue'
import './registerServiceWorker'
import router from './router/router'
import store from './store'
import VeeValidate from 'vee-validate'
import HoHo from '../hoho.config.js'
import Notifications from 'vue-notification'
import velocity from 'velocity-animate'
import PortalVue from 'portal-vue'
import VueQRCodeComponent from 'vue-qr-generator'

import './assets/scss/app.scss'
import './filters'
import { makeServer } from '@/mock/MockServer'

if (process.env.VUE_APP_MOCK_API === 'true') {
  makeServer()
}

Vue.use(HoHo)
Vue.use(Notifications, { velocity })
Vue.use(PortalVue)
Vue.component('qr-code', VueQRCodeComponent)

Vue.use(VeeValidate, {
  events: ''
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => {
    return (<ErrorWrapper><App /></ErrorWrapper>)
  }
}).$mount('#app')
/* eslint-enable */
